import { EmailRouting } from './EmailRouting'
import './styles.modules.scss'

export default EmailRouting
